"use client";
import { api } from "@/lib/api/api";
import { External, ExternalIdEntry } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";

export const useAvigilonExternalIds = ({
  id,
  object_type,
  enabled,
  addedIds
}: {
  id: string;
  object_type: string;
  enabled: boolean;
  addedIds: External[] | null;
}) => {
  return useQuery({
    queryKey: ["externalIds", id, object_type, addedIds?.length],

    queryFn: async () => {
      const resEntries = await api.client.avigilon.fetchAvigilonExternalIds();
      const entries = resEntries?.result?.entries;
      if (entries) {
        const filteredEntries = addedIds
          ? entries.reduce((acc: { value: string; label: string }[], entry) => {
              const isAdded = addedIds.some(
                (addedId) => String(addedId.external_id) === String(entry.id)
              );
              if (!isAdded) {
                acc.push(externalToSelectOption(entry));
              }
              return acc;
            }, [])
          : entries.map((entry) => externalToSelectOption(entry));

        return filteredEntries.length ? filteredEntries : noExternalIdLeft;
      }
      return noExternalIdAvailable;
    },

    enabled
  });
};

const externalToSelectOption = (external: ExternalIdEntry) => ({
  value: String(external.id),
  label: external.name
});

// none left to add after filtering from already added once
const noExternalIdLeft = [
  {
    value: "",
    label: "No external id is left"
  }
];

// none returned from the API
const noExternalIdAvailable = [
  {
    value: "",
    label: "No external id is available"
  }
];
